import { MutableRefObject } from 'react';
import { useOnScreen } from './useOnScreen';

export function useShowAnimation(ref: MutableRefObject<HTMLElement | null>) {
  const [, enterCount] = useOnScreen(ref);
  const showAnimation = (enterCount as number) >= 1;

  return showAnimation;
}
